import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import { Stack, Text, Toggle } from 'braid-design-system';
import { LoadingItem } from 'src/components/LoadingItem/LoadingItem';
import {
  useGetApproachability,
  useUpdateApproachability,
} from 'src/modules/graphql/visibility/data';
import { PageTitles } from 'src/components/Notifications/pageTitle';
import { useTypedSelector } from 'src/reducers';
import { trackApproachabilityUpdated } from 'src/modules/analytics/profileAnalytics';

export const EditApproachabilitySettings = () => {
  const { approachable, loading, error } = useGetApproachability();
  const { updateApproachability } = useUpdateApproachability();
  const brand = useTypedSelector((state) => state.page.pageAnalytics.brand);
  const { t } = useTranslations(translations);

  const onChangeFn = (approachableInput: boolean) => {
    updateApproachability({
      variables: { input: { approachable: approachableInput } },
    });

    trackApproachabilityUpdated({ approachable: approachableInput });
  };

  return (
    <Stack space="medium">
      <Text weight="strong">{t('Approachability')}</Text>
      <Text tone="secondary">
        {t(
          'Employers looking at a list of suitable profiles will see a label...',
          {
            brand: PageTitles[brand],
          },
        )}
      </Text>
      {loading || error ? (
        <LoadingItem size="large" width="full" />
      ) : (
        <Toggle
          id="approachabilityToggle"
          data={{ automation: 'approachability-toggle' }}
          label={t('Show my approachability')}
          on={approachable}
          onChange={onChangeFn}
          align="justify"
        />
      )}
    </Stack>
  );
};
